import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  disabled = false, 
  className = '', 
  onClick, 
  type = 'button',
  icon,
  iconPosition = 'left',
  fullWidth = false,
  loading = false,
  ...props 
}) => {
  const baseClasses = 'font-medium rounded-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 inline-flex items-center justify-center';
  
  const variantClasses = {
    primary: 'bg-hemp-green-600 hover:bg-hemp-green-700 text-white focus:ring-hemp-green-500',
    secondary: 'bg-hemp-brown-600 hover:bg-hemp-brown-700 text-white focus:ring-hemp-brown-500',
    danger: 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500',
    outline: 'border border-hemp-green-600 text-hemp-green-700 hover:bg-hemp-green-50 focus:ring-hemp-green-500',
    ghost: 'text-hemp-green-700 hover:bg-hemp-green-50 focus:ring-hemp-green-500',
    link: 'text-hemp-green-600 hover:text-hemp-green-800 underline hover:no-underline focus:ring-hemp-green-500',
    success: 'bg-hemp-leaf-600 hover:bg-hemp-leaf-700 text-white focus:ring-hemp-leaf-500'
  };
  
  const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
    xl: 'px-8 py-4 text-lg'
  };
  
  const disabledClasses = disabled 
    ? 'opacity-50 cursor-not-allowed' 
    : 'cursor-pointer';
  
  const widthClasses = fullWidth ? 'w-full' : '';
  
  const classes = [
    baseClasses,
    variantClasses[variant],
    sizeClasses[size],
    disabledClasses,
    widthClasses,
    className
  ].filter(Boolean).join(' ');
  
  const renderChildren = () => {
    if (!icon) return children;
    
    return (
      <>
        {iconPosition === 'left' && <span className="mr-2">{icon}</span>}
        {children}
        {iconPosition === 'right' && <span className="ml-2">{icon}</span>}
      </>
    );
  };
  
  return (
    <button
      type={type}
      className={classes}
      onClick={onClick}
      disabled={disabled || loading}
      {...(() => {
        // Remove loading prop before passing to DOM element
        const { loading, ...domProps } = props;
        return domProps;
      })()}
    >
      {loading ? (
        <span className="flex items-center">
          <span className="animate-spin mr-2">●</span>
          {children}
        </span>
      ) : (
        renderChildren()
      )}
    </button>
  );
};

export default Button;
